module.exports = __webpack_public_path__ + "static/img/banner-18-sept-belanda.f6148ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner-18-sept-belanda.png
// module id = dGMg
// module chunks = 1